import type { AxiosRequestConfig } from 'axios'

import { HttpService } from '@/infra/http'
import type { TParametrosSimulacao } from '@/types/parametros-simulacao'

export class GetParametrosSimulacao extends HttpService {
  execute = async (idExternoEmpreendimento: string) => {
    return this.http.get<TParametrosSimulacao, AxiosRequestConfig>(
      `/api/v2/Parametros/empreendimento/${idExternoEmpreendimento}/simulacao`,
    )
  }
}
